import { ErrorHandler, NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';
import Aura from '@primeuix/themes/aura';
// import { QuicklinkModule } from 'ngx-quicklink';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { providePrimeNG } from 'primeng/config';

import { DatadogErrorHandler } from 'datadog_config';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { DashboardNotificationsWidgetComponent } from "./core/pages/dashboard/widgets/notifications-widget/notifications-widget.component";
import { MobileScanningComponent } from './core/pages/mobile-scanning/mobile-scanning.component';
import { TrainingBannerComponent } from './core/layout/training-banner/training-banner.component';
import { CustomReuseStrategy } from './shared/navigation/custom-reuse-strategy';
import { QuickUserInfoComponent } from './shared/quick-user-info/quick-user-info.component';
import { TutorialOverlayComponent } from './shared/components/tutorial-overlay/tutorial-overlay.component';

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({
	declarations: [ AppComponent ]
	, bootstrap: [ AppComponent ]
	, imports: [
        BrowserModule
        , CoreModule
        // Uncomment to change chunk preloading strategy back to QuicklinkStrategy (only download chunks for links in the viewport)
        // , QuicklinkModule
        , ToastrModule.forRoot({ positionClass: 'toast-top-right', preventDuplicates: true, countDuplicates: true, resetTimeoutOnDuplicate: true })
        , BrowserAnimationsModule
        , ServiceWorkerModule.register(
            'ngsw-worker.js'
            , {
                enabled: true
                , registrationStrategy: 'registerWhenStable:30000'
            }
        )
        , DashboardNotificationsWidgetComponent
        , MatProgressSpinnerModule
        , QuickUserInfoComponent
        , MobileScanningComponent
        , TrainingBannerComponent
        , TutorialOverlayComponent
        , ConfirmDialogModule
    ]
	, providers: [
		{
			provide: ErrorHandler
			, useClass: DatadogErrorHandler
		}
        , ConfirmationService
        , {
            provide: SwRegistrationOptions
            , useFactory: () => ({ enabled: true })
        }
        , {
            provide: RouteReuseStrategy
            , useClass: CustomReuseStrategy
        }
        , provideAnimationsAsync()
        , providePrimeNG({
            theme: {
                preset: Aura
                , options: { darkModeSelector: false }
            }
        })
    ], exports: [
        DashboardNotificationsWidgetComponent
    ]
})
export class AppModule { }